// extracted by mini-css-extract-plugin
export default {"static-page-background":"D6qC_5","staticPageBackground":"D6qC_5","image":"YF69_C","user-message":"NSduxP","userMessage":"NSduxP","link":"ppOymz"};